export const ROUTES = {
  HOME: '/',
  STYLE_GUIDE: 'style',
  DASHBOARD: 'dashboard',
  PTE_ACADEMIC: '/pte-academic/:section',
  MOCK_TEST: 'mock-test',
  MOCK_TEXT_EXAM: 'exam/mock-test',
  MOCK_TEXT_INTRO: 'exam/mock-test/intro',
  MOCK_TEXT_DETAIL: 'exam/mock-test/detail',
  EXAM: 'exam',
  MOCK_TEST_DETAIL: 'mock-test/:id',
  PROFILE: 'profile',
  MANAGER_IMAGE: 'manager-image',
  RESULT: 'result',
  RESULT_DETAIL: 'result/:id',
};
